import React from 'react';

/**
 * ClassSelector — Dropdown to switch between class sections.
 * Shows "All Classes" + one option per section with student counts.
 */
const ClassSelector = ({ classSections = [], selectedClassId, onClassChange }) => {
  if (!classSections || classSections.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-3 mb-4">
      <label htmlFor="class-selector" className="text-sm font-medium text-gray-600">
        Viewing:
      </label>
      <select
        id="class-selector"
        value={selectedClassId || ''}
        onChange={(e) => onClassChange(e.target.value === '' ? null : parseInt(e.target.value, 10))}
        className="px-3 py-2 border border-gray-300 rounded-lg text-sm bg-white
                   focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500
                   shadow-sm cursor-pointer min-w-[200px]"
      >
        <option value="">All Classes ({classSections.reduce((sum, s) => sum + (s.student_count || 0), 0)} students)</option>
        {classSections.map((section) => (
          <option key={section.id} value={section.id}>
            {section.period_number ? `Period ${section.period_number} - ` : ''}
            {section.section_name} ({section.student_count || 0} students)
          </option>
        ))}
      </select>
    </div>
  );
};

export default ClassSelector;
